/* tslint:disable */
/* eslint-disable */
/**
 * Presentation API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { NeighborhoodMapSectionConfigDto } from './NeighborhoodMapSectionConfigDto';
import {
    NeighborhoodMapSectionConfigDtoFromJSON,
    NeighborhoodMapSectionConfigDtoFromJSONTyped,
    NeighborhoodMapSectionConfigDtoToJSON,
    NeighborhoodMapSectionConfigDtoToJSONTyped,
} from './NeighborhoodMapSectionConfigDto';
import type { TeamBrandingSectionConfigDto } from './TeamBrandingSectionConfigDto';
import {
    TeamBrandingSectionConfigDtoFromJSON,
    TeamBrandingSectionConfigDtoFromJSONTyped,
    TeamBrandingSectionConfigDtoToJSON,
    TeamBrandingSectionConfigDtoToJSONTyped,
} from './TeamBrandingSectionConfigDto';
import type { BrandingSectionConfigDto } from './BrandingSectionConfigDto';
import {
    BrandingSectionConfigDtoFromJSON,
    BrandingSectionConfigDtoFromJSONTyped,
    BrandingSectionConfigDtoToJSON,
    BrandingSectionConfigDtoToJSONTyped,
} from './BrandingSectionConfigDto';
import type { KeyFeaturesSectionConfigDto } from './KeyFeaturesSectionConfigDto';
import {
    KeyFeaturesSectionConfigDtoFromJSON,
    KeyFeaturesSectionConfigDtoFromJSONTyped,
    KeyFeaturesSectionConfigDtoToJSON,
    KeyFeaturesSectionConfigDtoToJSONTyped,
} from './KeyFeaturesSectionConfigDto';
import type { AIAssistedTextSectionConfigDto } from './AIAssistedTextSectionConfigDto';
import {
    AIAssistedTextSectionConfigDtoFromJSON,
    AIAssistedTextSectionConfigDtoFromJSONTyped,
    AIAssistedTextSectionConfigDtoToJSON,
    AIAssistedTextSectionConfigDtoToJSONTyped,
} from './AIAssistedTextSectionConfigDto';
import type { HeaderBrandingSectionConfigDto } from './HeaderBrandingSectionConfigDto';
import {
    HeaderBrandingSectionConfigDtoFromJSON,
    HeaderBrandingSectionConfigDtoFromJSONTyped,
    HeaderBrandingSectionConfigDtoToJSON,
    HeaderBrandingSectionConfigDtoToJSONTyped,
} from './HeaderBrandingSectionConfigDto';
import type { FreeHtmlTextSectionConfigDto } from './FreeHtmlTextSectionConfigDto';
import {
    FreeHtmlTextSectionConfigDtoFromJSON,
    FreeHtmlTextSectionConfigDtoFromJSONTyped,
    FreeHtmlTextSectionConfigDtoToJSON,
    FreeHtmlTextSectionConfigDtoToJSONTyped,
} from './FreeHtmlTextSectionConfigDto';
import type { FreeTextSectionConfigDto } from './FreeTextSectionConfigDto';
import {
    FreeTextSectionConfigDtoFromJSON,
    FreeTextSectionConfigDtoFromJSONTyped,
    FreeTextSectionConfigDtoToJSON,
    FreeTextSectionConfigDtoToJSONTyped,
} from './FreeTextSectionConfigDto';
import type { HeaderSectionConfig } from './HeaderSectionConfig';
import {
    HeaderSectionConfigFromJSON,
    HeaderSectionConfigFromJSONTyped,
    HeaderSectionConfigToJSON,
    HeaderSectionConfigToJSONTyped,
} from './HeaderSectionConfig';
import type { InsightsSectionConfigDto } from './InsightsSectionConfigDto';
import {
    InsightsSectionConfigDtoFromJSON,
    InsightsSectionConfigDtoFromJSONTyped,
    InsightsSectionConfigDtoToJSON,
    InsightsSectionConfigDtoToJSONTyped,
} from './InsightsSectionConfigDto';
import type { GeneralHeaderSectionConfigDto } from './GeneralHeaderSectionConfigDto';
import {
    GeneralHeaderSectionConfigDtoFromJSON,
    GeneralHeaderSectionConfigDtoFromJSONTyped,
    GeneralHeaderSectionConfigDtoToJSON,
    GeneralHeaderSectionConfigDtoToJSONTyped,
} from './GeneralHeaderSectionConfigDto';
import type { AgentInfoSectionConfigDto } from './AgentInfoSectionConfigDto';
import {
    AgentInfoSectionConfigDtoFromJSON,
    AgentInfoSectionConfigDtoFromJSONTyped,
    AgentInfoSectionConfigDtoToJSON,
    AgentInfoSectionConfigDtoToJSONTyped,
} from './AgentInfoSectionConfigDto';
import type { SideBySideComparisionConfigDto } from './SideBySideComparisionConfigDto';
import {
    SideBySideComparisionConfigDtoFromJSON,
    SideBySideComparisionConfigDtoFromJSONTyped,
    SideBySideComparisionConfigDtoToJSON,
    SideBySideComparisionConfigDtoToJSONTyped,
} from './SideBySideComparisionConfigDto';

/**
 * 
 * @export
 * @interface PresentationConfigDtoSectionsInner
 */
export interface PresentationConfigDtoSectionsInner {
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    id: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    navTitle?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    visibility?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    type: string;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showPriceRange?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showDaysOnMarket?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showClientName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showPresentationTitle?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    city?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    state?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    area?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    neighborhood?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    isLease?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    propertyType?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    propertyTypeRaw?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    propertySubTypeRaw?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showMedianSalesPriceYearComparision?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showAverageLivingSpaceSqftPrice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showInventorySpeedComparison?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    title?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showListPrice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showSoldPrice?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showYearBuilt?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showNeighborhood?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showLivingSpace?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showBeds?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showBaths?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showPricePerLivingSpaceSqft?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showGarageParkingSpaces?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showHOAFees?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showLotSize?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showPropertyType?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showDoormanAttendance?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showRoomsTotal?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showFlipTaxRemarks?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showRecurringCosts?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    description?: string;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showListDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showSoldDate?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showListingStatus?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showCumulativeDaysOnMarket?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    content: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    bio?: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    htmlContent: string;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    agentName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    agentTitle?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    agentEmail?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    agentPhoneNumber?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    agentAvatar?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    officeName?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    officeLogo?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    website?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    instagramUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    facebookUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    xUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    youtubeUrl?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    linkedInUrl?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showAgentName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showAgentTitle?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showAgentEmail?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showAgentPhoneNumber?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showAgentAvatar?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showOfficeName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showOfficeLogo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showWebsite?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showInstagramUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showFacebookUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showXUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showYoutubeUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showLinkedInUrl?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    shouldFetchFromUserProfile?: boolean;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    name?: string | null;
    /**
     * 
     * @type {string}
     * @memberof PresentationConfigDtoSectionsInner
     */
    logo?: string | null;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showName?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showLogo?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof PresentationConfigDtoSectionsInner
     */
    showMlsSourceInfo?: boolean;
}

/**
 * Check if a given object implements the PresentationConfigDtoSectionsInner interface.
 */
export function instanceOfPresentationConfigDtoSectionsInner(value: object): value is PresentationConfigDtoSectionsInner {
    if (!('id' in value) || value['id'] === undefined) return false;
    if (!('type' in value) || value['type'] === undefined) return false;
    if (!('content' in value) || value['content'] === undefined) return false;
    if (!('htmlContent' in value) || value['htmlContent'] === undefined) return false;
    return true;
}

export function PresentationConfigDtoSectionsInnerFromJSON(json: any): PresentationConfigDtoSectionsInner {
    return PresentationConfigDtoSectionsInnerFromJSONTyped(json, false);
}

export function PresentationConfigDtoSectionsInnerFromJSONTyped(json: any, ignoreDiscriminator: boolean): PresentationConfigDtoSectionsInner {
    if (json == null) {
        return json;
    }
    if (!ignoreDiscriminator) {
    }
    return {
        
        'id': json['id'],
        'navTitle': json['navTitle'] == null ? undefined : json['navTitle'],
        'visibility': json['visibility'] == null ? undefined : json['visibility'],
        'type': json['type'],
        'showPriceRange': json['showPriceRange'] == null ? undefined : json['showPriceRange'],
        'showDaysOnMarket': json['showDaysOnMarket'] == null ? undefined : json['showDaysOnMarket'],
        'showClientName': json['showClientName'] == null ? undefined : json['showClientName'],
        'showPresentationTitle': json['showPresentationTitle'] == null ? undefined : json['showPresentationTitle'],
        'city': json['city'] == null ? undefined : json['city'],
        'state': json['state'] == null ? undefined : json['state'],
        'area': json['area'] == null ? undefined : json['area'],
        'neighborhood': json['neighborhood'] == null ? undefined : json['neighborhood'],
        'isLease': json['isLease'] == null ? undefined : json['isLease'],
        'propertyType': json['propertyType'] == null ? undefined : json['propertyType'],
        'propertyTypeRaw': json['propertyTypeRaw'] == null ? undefined : json['propertyTypeRaw'],
        'propertySubTypeRaw': json['propertySubTypeRaw'] == null ? undefined : json['propertySubTypeRaw'],
        'showMedianSalesPriceYearComparision': json['showMedianSalesPriceYearComparision'] == null ? undefined : json['showMedianSalesPriceYearComparision'],
        'showAverageLivingSpaceSqftPrice': json['showAverageLivingSpaceSqftPrice'] == null ? undefined : json['showAverageLivingSpaceSqftPrice'],
        'showInventorySpeedComparison': json['showInventorySpeedComparison'] == null ? undefined : json['showInventorySpeedComparison'],
        'title': json['title'] == null ? undefined : json['title'],
        'showListPrice': json['showListPrice'] == null ? undefined : json['showListPrice'],
        'showSoldPrice': json['showSoldPrice'] == null ? undefined : json['showSoldPrice'],
        'showYearBuilt': json['showYearBuilt'] == null ? undefined : json['showYearBuilt'],
        'showNeighborhood': json['showNeighborhood'] == null ? undefined : json['showNeighborhood'],
        'showLivingSpace': json['showLivingSpace'] == null ? undefined : json['showLivingSpace'],
        'showBeds': json['showBeds'] == null ? undefined : json['showBeds'],
        'showBaths': json['showBaths'] == null ? undefined : json['showBaths'],
        'showPricePerLivingSpaceSqft': json['showPricePerLivingSpaceSqft'] == null ? undefined : json['showPricePerLivingSpaceSqft'],
        'showGarageParkingSpaces': json['showGarageParkingSpaces'] == null ? undefined : json['showGarageParkingSpaces'],
        'showHOAFees': json['showHOAFees'] == null ? undefined : json['showHOAFees'],
        'showLotSize': json['showLotSize'] == null ? undefined : json['showLotSize'],
        'showPropertyType': json['showPropertyType'] == null ? undefined : json['showPropertyType'],
        'showDoormanAttendance': json['showDoormanAttendance'] == null ? undefined : json['showDoormanAttendance'],
        'showRoomsTotal': json['showRoomsTotal'] == null ? undefined : json['showRoomsTotal'],
        'showFlipTaxRemarks': json['showFlipTaxRemarks'] == null ? undefined : json['showFlipTaxRemarks'],
        'showRecurringCosts': json['showRecurringCosts'] == null ? undefined : json['showRecurringCosts'],
        'description': json['description'] == null ? undefined : json['description'],
        'showListDate': json['showListDate'] == null ? undefined : json['showListDate'],
        'showSoldDate': json['showSoldDate'] == null ? undefined : json['showSoldDate'],
        'showListingStatus': json['showListingStatus'] == null ? undefined : json['showListingStatus'],
        'showCumulativeDaysOnMarket': json['showCumulativeDaysOnMarket'] == null ? undefined : json['showCumulativeDaysOnMarket'],
        'content': json['content'],
        'bio': json['bio'] == null ? undefined : json['bio'],
        'htmlContent': json['htmlContent'],
        'agentName': json['agentName'] == null ? undefined : json['agentName'],
        'agentTitle': json['agentTitle'] == null ? undefined : json['agentTitle'],
        'agentEmail': json['agentEmail'] == null ? undefined : json['agentEmail'],
        'agentPhoneNumber': json['agentPhoneNumber'] == null ? undefined : json['agentPhoneNumber'],
        'agentAvatar': json['agentAvatar'] == null ? undefined : json['agentAvatar'],
        'officeName': json['officeName'] == null ? undefined : json['officeName'],
        'officeLogo': json['officeLogo'] == null ? undefined : json['officeLogo'],
        'website': json['website'] == null ? undefined : json['website'],
        'instagramUrl': json['instagramUrl'] == null ? undefined : json['instagramUrl'],
        'facebookUrl': json['facebookUrl'] == null ? undefined : json['facebookUrl'],
        'xUrl': json['xUrl'] == null ? undefined : json['xUrl'],
        'youtubeUrl': json['youtubeUrl'] == null ? undefined : json['youtubeUrl'],
        'linkedInUrl': json['linkedInUrl'] == null ? undefined : json['linkedInUrl'],
        'showAgentName': json['showAgentName'] == null ? undefined : json['showAgentName'],
        'showAgentTitle': json['showAgentTitle'] == null ? undefined : json['showAgentTitle'],
        'showAgentEmail': json['showAgentEmail'] == null ? undefined : json['showAgentEmail'],
        'showAgentPhoneNumber': json['showAgentPhoneNumber'] == null ? undefined : json['showAgentPhoneNumber'],
        'showAgentAvatar': json['showAgentAvatar'] == null ? undefined : json['showAgentAvatar'],
        'showOfficeName': json['showOfficeName'] == null ? undefined : json['showOfficeName'],
        'showOfficeLogo': json['showOfficeLogo'] == null ? undefined : json['showOfficeLogo'],
        'showWebsite': json['showWebsite'] == null ? undefined : json['showWebsite'],
        'showInstagramUrl': json['showInstagramUrl'] == null ? undefined : json['showInstagramUrl'],
        'showFacebookUrl': json['showFacebookUrl'] == null ? undefined : json['showFacebookUrl'],
        'showXUrl': json['showXUrl'] == null ? undefined : json['showXUrl'],
        'showYoutubeUrl': json['showYoutubeUrl'] == null ? undefined : json['showYoutubeUrl'],
        'showLinkedInUrl': json['showLinkedInUrl'] == null ? undefined : json['showLinkedInUrl'],
        'shouldFetchFromUserProfile': json['shouldFetchFromUserProfile'] == null ? undefined : json['shouldFetchFromUserProfile'],
        'name': json['name'] == null ? undefined : json['name'],
        'logo': json['logo'] == null ? undefined : json['logo'],
        'showName': json['showName'] == null ? undefined : json['showName'],
        'showLogo': json['showLogo'] == null ? undefined : json['showLogo'],
        'showMlsSourceInfo': json['showMlsSourceInfo'] == null ? undefined : json['showMlsSourceInfo'],
    };
}

export function PresentationConfigDtoSectionsInnerToJSON(json: any): PresentationConfigDtoSectionsInner {
    return PresentationConfigDtoSectionsInnerToJSONTyped(json, false);
}

export function PresentationConfigDtoSectionsInnerToJSONTyped(value?: PresentationConfigDtoSectionsInner | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    if (!ignoreDiscriminator) {
        switch (value['type']) {
            default:
                return value;
        }
    }

    return {
        
        'id': value['id'],
        'navTitle': value['navTitle'],
        'visibility': value['visibility'],
        'type': value['type'],
        'showPriceRange': value['showPriceRange'],
        'showDaysOnMarket': value['showDaysOnMarket'],
        'showClientName': value['showClientName'],
        'showPresentationTitle': value['showPresentationTitle'],
        'city': value['city'],
        'state': value['state'],
        'area': value['area'],
        'neighborhood': value['neighborhood'],
        'isLease': value['isLease'],
        'propertyType': value['propertyType'],
        'propertyTypeRaw': value['propertyTypeRaw'],
        'propertySubTypeRaw': value['propertySubTypeRaw'],
        'showMedianSalesPriceYearComparision': value['showMedianSalesPriceYearComparision'],
        'showAverageLivingSpaceSqftPrice': value['showAverageLivingSpaceSqftPrice'],
        'showInventorySpeedComparison': value['showInventorySpeedComparison'],
        'title': value['title'],
        'showListPrice': value['showListPrice'],
        'showSoldPrice': value['showSoldPrice'],
        'showYearBuilt': value['showYearBuilt'],
        'showNeighborhood': value['showNeighborhood'],
        'showLivingSpace': value['showLivingSpace'],
        'showBeds': value['showBeds'],
        'showBaths': value['showBaths'],
        'showPricePerLivingSpaceSqft': value['showPricePerLivingSpaceSqft'],
        'showGarageParkingSpaces': value['showGarageParkingSpaces'],
        'showHOAFees': value['showHOAFees'],
        'showLotSize': value['showLotSize'],
        'showPropertyType': value['showPropertyType'],
        'showDoormanAttendance': value['showDoormanAttendance'],
        'showRoomsTotal': value['showRoomsTotal'],
        'showFlipTaxRemarks': value['showFlipTaxRemarks'],
        'showRecurringCosts': value['showRecurringCosts'],
        'description': value['description'],
        'showListDate': value['showListDate'],
        'showSoldDate': value['showSoldDate'],
        'showListingStatus': value['showListingStatus'],
        'showCumulativeDaysOnMarket': value['showCumulativeDaysOnMarket'],
        'content': value['content'],
        'bio': value['bio'],
        'htmlContent': value['htmlContent'],
        'agentName': value['agentName'],
        'agentTitle': value['agentTitle'],
        'agentEmail': value['agentEmail'],
        'agentPhoneNumber': value['agentPhoneNumber'],
        'agentAvatar': value['agentAvatar'],
        'officeName': value['officeName'],
        'officeLogo': value['officeLogo'],
        'website': value['website'],
        'instagramUrl': value['instagramUrl'],
        'facebookUrl': value['facebookUrl'],
        'xUrl': value['xUrl'],
        'youtubeUrl': value['youtubeUrl'],
        'linkedInUrl': value['linkedInUrl'],
        'showAgentName': value['showAgentName'],
        'showAgentTitle': value['showAgentTitle'],
        'showAgentEmail': value['showAgentEmail'],
        'showAgentPhoneNumber': value['showAgentPhoneNumber'],
        'showAgentAvatar': value['showAgentAvatar'],
        'showOfficeName': value['showOfficeName'],
        'showOfficeLogo': value['showOfficeLogo'],
        'showWebsite': value['showWebsite'],
        'showInstagramUrl': value['showInstagramUrl'],
        'showFacebookUrl': value['showFacebookUrl'],
        'showXUrl': value['showXUrl'],
        'showYoutubeUrl': value['showYoutubeUrl'],
        'showLinkedInUrl': value['showLinkedInUrl'],
        'shouldFetchFromUserProfile': value['shouldFetchFromUserProfile'],
        'name': value['name'],
        'logo': value['logo'],
        'showName': value['showName'],
        'showLogo': value['showLogo'],
        'showMlsSourceInfo': value['showMlsSourceInfo'],
    };
}

